<template>
  <!-- Modal para visualização DICOM e laudo -->
  <div v-if="isVisible"
    :class="[modoPainel ? 'laudo-panel-root' : 'fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50']">
    <div
      :class="[modoPainel ? 'laudo-panel-content' : 'bg-white dark:bg-gray-800 rounded-lg shadow-lg w-11/12 max-w-7xl h-5/6 flex flex-col overflow-hidden', panelClasses]">
              <!-- Cabeçalho do modal -->
        <div class="px-6 py-4 border-b dark:border-gray-700 flex-shrink-0">
        <div class="flex justify-between items-start mb-2">
          <div class="flex-1">
            <h3 class="text-lg font-bold text-gray-800 dark:text-white">
              {{ paciente?.nome }} - {{ paciente?.exame }}
            </h3>
            <p class="text-sm text-gray-600 dark:text-white">
              ID: {{ paciente?.idPaciente }} | Acesso: {{ paciente?.numAcesso }} | Data: {{
                formatarDataExame(paciente?.data) }}
              <span v-if="laudoAtual?.service_name" class="ml-2">| Serviço: {{ laudoAtual.service_name }}</span>
            </p>
          </div>
          <button @click="fecharModal"
            class="text-gray-500 hover:text-gray-700 dark:text-white dark:hover:text-gray-300">
            <X class="h-6 w-6" />
          </button>
        </div>

        <!-- Informações de status e workflow -->
        <div v-if="laudoAtual" class="flex items-center justify-between">
          <div class="flex items-center space-x-4">
            <!-- Status do laudo -->
            <div class="flex items-center space-x-2">
              <span class="text-sm font-medium text-gray-600 dark:text-gray-300">Status:</span>
              <span :style="getStatusStyle(displayStatus)"
                class="px-3 py-1.5 rounded-md text-xs font-medium flex items-center gap-1">
                <component :is="statusIcons[displayStatusFormatado.icon]" class="h-3 w-3" />
                {{ displayStatusFormatado.label }}
              </span>
            </div>
          </div>

          <div v-if="isMedico" class="flex items-center space-x-2">
            <RecallPatientButton
                  v-if="isMedico && paciente && paciente.numAcesso && currentAppointment && currentAppointment.can_recall && canRecall && !isRecallBlocked"
                  :appointment="currentAppointment"
                  :disabled="!canRecall"
                  @recall-patient="handleRecallPatientFromComponent"
                />
            <button @click="mostrarTimeline = !mostrarTimeline"
              class="px-3 py-1 bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-800 dark:text-white rounded-md text-sm flex items-center gap-2">
              <History class="h-4 w-4" />
              <span>Timeline</span>
            </button>
            <!--  <button
              class="px-3 py-1 bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-800 dark:text-white rounded-md text-sm">
              Exames anteriores
            </button> -->
          </div>
        </div>



        <!-- Timeline expandida -->
        <div v-if="mostrarTimeline && timelineLaudo.length > 0"
          class="mt-3 p-3 bg-gray-50 dark:bg-gray-700 rounded-md max-h-64 overflow-y-auto">
          <h4 class="text-sm font-medium text-gray-800 dark:text-white mb-2">Timeline do Laudo</h4>
          <ul class="space-y-3">
            <li v-for="item in timelineLaudo" :key="`${item.type}-${item.timestamp}`" class="flex items-start">
              <div class="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center mr-3"
                :class="getTimelineIcon(item.type).bgClass">
                <component :is="getTimelineIcon(item.type).icon" :class="getTimelineIcon(item.type).iconClass"
                  class="h-5 w-5" />
              </div>
              <div class="flex-1">
                <div class="text-sm">
                  <span class="font-medium text-gray-800 dark:text-gray-200">{{ item.action }}</span>
                  <span class="text-gray-600 dark:text-gray-400"> por {{ item.user }}</span>
                </div>
                <div class="text-xs text-gray-500 dark:text-gray-400">{{ formatarData(item.timestamp) }}</div>
                <div v-if="item.notes"
                  class="mt-1 p-2 bg-gray-100 dark:bg-gray-600 rounded-md text-xs text-gray-700 dark:text-gray-300">
                  <strong v-if="item.type === 'addenda'">Conteúdo do adendo:</strong>
                  <strong v-else-if="item.type === 'review'">Conteúdo da revisão:</strong>
                  <span v-if="item.type === 'addenda' || item.type === 'review'" v-html="item.notes"></span>
                  <span v-else>{{ item.notes }}</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <!-- Conteúdo do modal -->
      <div class="flex flex-1 overflow-hidden min-h-0">
        <!-- Visualizador DICOM (apenas para médicos, não em popup) -->
        <!-- O visualizador DICOM é ocultado quando modoPopup=true para economizar espaço na popup -->
        <div v-if="!modoPainel && !modoPopup && isMedico" class="w-2/3 bg-black flex flex-col">
          <div class="flex-grow flex items-center justify-center">
            <iframe v-if="paciente" :src="`/viewer/?accession_number=${paciente.numero}`"
              class="w-full h-full border-0 rounded" style="min-height: 600px;" referrerpolicy="same-origin"
              sandbox="allow-scripts allow-same-origin allow-forms allow-popups"></iframe>
            <div v-else class="text-white text-center w-full">
              Selecione um exame para visualizar o DICOM.
            </div>
          </div>
        </div>

                <!-- Editor de laudo ou Visualizador PDF -->
        <div :class="[
          modoPainel ? 'w-full' : 
          (isMedico && !modoPopup) ? 'w-1/3' : 'w-full', 
          'p-4 flex flex-col h-full'
        ]">
          <div class="flex justify-between items-center mb-4">
            <h4 class="font-bold text-gray-800 dark:text-white">
              {{ isMedico ? 'Laudo Médico' : 'Visualização do Laudo' }}
            </h4>
            <div v-if="isMedico && !mostrarAvisoAgendamento" class="flex space-x-2">
              <select v-model="mascaraSelecionada" @change="aplicarMascara"
                class="text-sm border rounded-md px-2 py-1 bg-white dark:bg-gray-700 dark:text-white dark:border-gray-600"
                :disabled="carregandoMascaras || (!podeEditar && activeTab === 'laudo')">
                <option value="">
                  {{ carregandoMascaras ? 'Carregando...' :
                    mascaras.length === 0 ? 'Nenhuma máscara disponível' :
                      (!podeEditar && activeTab === 'laudo') ? 'Não disponíveis para laudo finalizado' :
                        'Aplicar template de máscara' }}
                </option>
                <option v-for="mascara in mascaras.filter(m => m && m.id)" :key="mascara.id" :value="mascara.id">
                  {{ mascara.nome || mascara.name || 'Máscara sem nome' }}
                </option>
              </select>
              <button @click="abrirModalMascara"
                class="p-1 rounded-md hover:bg-gray-200 dark:hover:bg-gray-700 text-[#00a99d]"
                :class="{ 'opacity-50 cursor-not-allowed': !podeEditar && activeTab === 'laudo' }"
                :disabled="!podeEditar && activeTab === 'laudo'" title="Nova máscara">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                  stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                </svg>
              </button>
            </div>
          </div>

          <!-- AVISO DE AGENDAMENTO NÃO ENCONTRADO OU RECONVOCAÇÃO BLOQUEADA (PRIORIDADE MÁXIMA) -->
          <div v-if="mostrarAvisoAgendamento || (isRecallBlocked && isMedico)" class="flex-1 flex items-center justify-center p-8" :key="'aviso-' + (mostrarAvisoAgendamento ? 'agendamento' : 'recall')">
            <div class="text-center max-w-md">
              <div class="mb-4">
                <svg v-if="mostrarAvisoAgendamento" class="mx-auto h-12 w-12 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                </svg>
                <svg v-else-if="isRecallBlocked && isMedico" class="mx-auto h-12 w-12 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                </svg>
              </div>
              <h3 v-if="mostrarAvisoAgendamento" class="text-lg font-medium text-gray-900 dark:text-white mb-2">
                Agendamento Não Encontrado
              </h3>
              <h3 v-else-if="isRecallBlocked && isMedico" class="text-lg font-medium text-gray-900 dark:text-white mb-2">
                Exame em Reconvocação - Laudo Bloqueado
              </h3>
              <div v-if="mostrarAvisoAgendamento" class="text-sm text-gray-600 dark:text-gray-400 whitespace-pre-line">
                {{ mensagemAvisoAgendamento }}
              </div>
              <div v-else-if="isRecallBlocked && isMedico" class="text-sm text-gray-600 dark:text-gray-400 space-y-2">
                <p><strong>Motivo:</strong> {{ recallReason }}</p>
                <p v-if="recallDescription"><strong>Descrição:</strong> {{ recallDescription }}</p>
                <p><strong>Status:</strong> 
                  <span class="capitalize">{{ recallStatus === 'pending' ? 'Pendente' : 
                    recallStatus === 'scheduled' ? 'Agendado' : 
                    recallStatus === 'completed' ? 'Concluído' : 
                    recallStatus === 'cancelled' ? 'Cancelado' : recallStatus }}</span>
                </p>
                <p v-if="recallStatus === 'scheduled' && recallInfo?.rescheduled_date && recallInfo?.rescheduled_time">
                  <strong>Novo Agendamento:</strong> {{ formatDateBR(recallInfo.rescheduled_date) }} às {{ recallInfo.rescheduled_time }}
                  <span v-if="recallInfo?.scheduled_by" class="block text-xs text-gray-500 mt-1">
                    Agendado por: {{ recallInfo.scheduled_by }}
                  </span>
                </p>
                <p v-if="recallStatus === 'completed' && recallInfo?.rescheduled_date && recallInfo?.rescheduled_time">
                  <strong>Agendamento Realizado:</strong> {{ formatDateBR(recallInfo.rescheduled_date) }} às {{ recallInfo.rescheduled_time }}
                  <span v-if="recallInfo?.scheduled_by" class="block text-xs text-gray-500 mt-1">
                    Agendado por: {{ recallInfo.scheduled_by }}
                  </span>
                </p>
                <p v-if="recallBlockedAt" class="text-xs text-gray-500">
                  <strong>Solicitado em:</strong> {{ formatarData(recallBlockedAt) }}
                </p>
                <div class="mt-3 p-3 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-md">
                  <div class="flex items-start">
                    <div class="flex-shrink-0">
                      <svg class="h-4 w-4 text-amber-600 dark:text-amber-400 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                      </svg>
                    </div>
                    <div class="ml-2">
                      <div class="text-xs text-amber-700 dark:text-amber-300">
                        <p class="font-medium mb-1">Laudo bloqueado - continuidade no novo agendamento</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-4">
                <button @click="fecharModal"
                  class="px-4 py-2 bg-gray-600 hover:bg-gray-700 text-white rounded-md text-sm">
                  Fechar
                </button>
              </div>
            </div>
          </div>



          <!-- Indicador de carregamento -->
          <div v-if="carregandoLaudo" class="flex-1 flex items-center justify-center p-8">
            <div class="text-center">
              <svg class="animate-spin h-12 w-12 mx-auto mb-4 text-blue-600 dark:text-blue-400" xmlns="http://www.w3.org/2000/svg"
                fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                </path>
              </svg>
              <p class="text-gray-600 dark:text-gray-400 text-lg font-medium">Carregando informações do laudo...</p>
              <p class="text-gray-500 dark:text-gray-500 text-sm mt-2">Aguarde enquanto buscamos os dados do paciente</p>
            </div>
          </div>

          <!-- SE O LAUDO ESTIVER EDITÁVEL (APENAS PARA MÉDICOS) -->
          <div v-else-if="podeEditar && isMedico && !carregandoLaudo" class="flex flex-col h-full" style="min-height: 400px;">
            <!-- Aviso de série de impressão necessária -->
            <div v-if="!hasPrintSeries && !canLaudoWithoutPrintSeries" class="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4 mb-4">
              <div class="flex items-start">
                <div class="flex-shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                  </svg>
                </div>
                <div class="ml-3">
                  <h3 class="text-sm font-medium text-red-800 dark:text-red-200">Série de Impressão Necessária</h3>
                  <div class="mt-2 text-sm text-red-700 dark:text-red-300">
                    <p>Este serviço requer que uma série de impressão seja criada antes de permitir o laudo. Por favor, crie a série de impressão primeiro.</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- Área do Editor (com altura flexível) -->
            <div class="flex-1 min-h-0" style="max-height: calc(100vh - 400px);">
              <QuillEditor ref="quillEditor" v-model:content="conteudoLaudo" content-type="html" :options="editorOptions"
                class="h-full border rounded-md quill-editor-custom" :class="{ 'opacity-50': salvandoLaudo }"
                @update:content="onContentChange" @ready="onEditorReady" style="min-height: 300px;" />
            </div>
            
            <!-- Indicador de salvamento automático -->
            <div class="flex-shrink-0 flex items-center justify-between mt-2 text-xs">
              <div class="flex items-center gap-2">
                <!-- Estado de salvamento -->
                <div v-if="salvandoAutomaticamente" class="flex items-center text-blue-600 dark:text-blue-400">
                  <svg class="animate-spin h-3 w-3 mr-1" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                    </path>
                  </svg>
                  <span class="font-medium">Salvando automaticamente...</span>
                </div>

                <!-- Estado de salvamento manual -->
                <div v-else-if="salvandoLaudo" class="flex items-center text-blue-600 dark:text-blue-400">
                  <svg class="animate-spin h-3 w-3 mr-1" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                    </path>
                  </svg>
                  <span class="font-medium">Salvando...</span>
                </div>

                <!-- Último salvamento bem-sucedido -->
                <div v-else-if="ultimoSalvamento" class="flex items-center text-green-600 dark:text-green-400">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 mr-1" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span class="font-medium">Salvo {{ ultimoSalvamento }}</span>
                </div>

                <!-- Estado inicial -->
                <div v-else class="flex items-center text-gray-500 dark:text-gray-400">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 mr-1" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span>Pronto para salvar</span>
                </div>
              </div>

              <!-- Contador de caracteres -->
              <div class="text-gray-500 dark:text-gray-400 font-mono">
                {{ contadorCaracteres }} caracteres
              </div>
            </div>
          </div>

          <!-- SE O LAUDO ESTIVER FINALIZADO (VISÃO DE ABAS) - APENAS PARA MÉDICOS -->
          <div v-else-if="!carregandoLaudo && isMedico" class="flex flex-col h-full" style="min-height: 400px;">
            <!-- Navegação das Abas -->
            <div class="flex-shrink-0 border-b dark:border-gray-600 mb-2">
              <button @click="activeTab = 'laudo'" :class="[
                'px-4 py-2 text-sm font-medium',
                activeTab === 'laudo'
                  ? 'border-b-2 border-teal-500 text-teal-600 dark:text-teal-400'
                  : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200'
              ]">
                Laudo Principal
              </button>
              <button v-if="podeAdicionarAdendo && laudoAtual?.status !== 'REVIEWED'" @click="activeTab = 'adendo'" :class="[
                'px-4 py-2 text-sm font-medium',
                activeTab === 'adendo'
                  ? 'border-b-2 border-teal-500 text-teal-600 dark:text-teal-400'
                  : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200'
              ]">
                Novo Adendo
              </button>
              <button v-if="podeRevisar" @click="activeTab = 'revisao'" :class="[
                'px-4 py-2 text-sm font-medium',
                activeTab === 'revisao'
                  ? 'border-b-2 border-purple-500 text-purple-600 dark:text-purple-400'
                  : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200'
              ]">
                Revisar Laudo
              </button>
            </div>

            <!-- Conteúdo da Aba Laudo (Somente Leitura) -->
            <div v-show="activeTab === 'laudo'"
              class="flex-1 min-h-0 p-3 border rounded-md bg-gray-50 dark:bg-gray-900 overflow-y-auto" style="max-height: calc(100vh - 450px);">
              <div v-html="laudoCompletoParaExibicao" class="prose dark:prose-invert max-w-none"></div>
            </div>

            <!-- Conteúdo da Aba Adendo (Editor) -->
            <div v-show="activeTab === 'adendo'" class="flex-1 flex flex-col min-h-0"
              style="max-height: calc(100vh - 450px);">
              <div class="flex-1 min-h-0">
                <QuillEditor ref="quillAdendoEditor" v-model:content="novoAdendoConteudo" content-type="html"
                  :options="editorOptions" class="h-full border rounded-md quill-editor-custom"
                  placeholder="Digite o conteúdo do novo adendo aqui..." style="min-height: 250px;" />
              </div>
              <div class="flex-shrink-0 flex justify-end mt-2">
                <button @click="finalizarAdendo" :disabled="salvandoAdendo"
                  class="px-4 py-2 bg-orange-600 hover:bg-orange-700 text-white rounded-md text-sm flex items-center gap-2 transition-colors disabled:opacity-50"
                  title="Finalizar e salvar o adendo atual">
                  <svg v-if="salvandoAdendo" class="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                    </path>
                  </svg>
                  <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>{{ salvandoAdendo ? 'Finalizando...' : 'Finalizar Adendo' }}</span>
                </button>
              </div>
            </div>

            <!-- Conteúdo da Aba Revisão (Editor) -->
            <div v-show="activeTab === 'revisao'" class="flex-1 flex flex-col min-h-0"
              style="max-height: calc(100vh - 450px);">
              
              <div class="flex-1 min-h-0">
                <QuillEditor ref="quillRevisaoEditor" v-model:content="notasRevisao" content-type="html"
                  :options="editorOptions" class="h-full border rounded-md quill-editor-custom"
                  placeholder="Digite suas observações sobre a revisão do laudo aqui..." style="min-height: 250px;" />
              </div>


            </div>
          </div>

          <!-- SE O USUÁRIO NÃO FOR MÉDICO - MOSTRAR APENAS PDF OU MENSAGEM DE INDISPONIBILIDADE -->
          <div v-else-if="!carregandoLaudo && !isMedico && laudoAtual" class="flex-1 flex flex-col min-h-0">
            <!-- Se o laudo estiver pendente, mostrar apenas mensagem de indisponibilidade -->
            <div v-if="laudoAtual.status === 'PENDING'" class="flex-1 flex items-center justify-center">
              <div class="text-center max-w-md mx-auto">
                <div class="mb-6">
                  <div class="w-20 h-20 mx-auto relative">
                    <div class="absolute inset-0 rounded-full bg-gradient-to-r from-amber-400 to-orange-500 opacity-20 animate-pulse"></div>
                    <div class="absolute inset-2 rounded-full bg-white dark:bg-gray-800 flex items-center justify-center">
                      <svg class="w-8 h-8 text-amber-600 dark:text-amber-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                      </svg>
                    </div>
                  </div>
                </div>
                
                <div class="space-y-3">
                  <h3 class="text-lg font-medium text-gray-900 dark:text-white flex items-center justify-center gap-2">
                    <svg class="w-5 h-5 text-amber-600 dark:text-amber-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                    </svg>
                    PDF Laudo Não Disponível
                  </h3>
                  
                  <div class="bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg p-4">
                    <p class="text-sm text-amber-800 dark:text-amber-200 leading-relaxed">
                      O laudo ainda está pendente e não foi finalizado. O PDF estará disponível após a finalização do laudo pelo médico.
                    </p>
                  </div>
                  
                  <div class="text-xs text-gray-500 dark:text-gray-400 space-y-1">
                    <p>• O laudo está sendo preparado pelo médico</p>
                    <p>• O PDF será gerado automaticamente após a finalização</p>
                    <p>• Entre em contato com a clínica se o problema persistir</p>
                  </div>
                </div>
                
                <div class="mt-6 space-y-2">
                  <button @click="fecharModal"
                    class="w-full px-4 py-2 bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-800 dark:text-white rounded-md text-sm transition-colors">
                    Fechar
                  </button>
                </div>
              </div>
            </div>

            <!-- Se o laudo não estiver pendente, mostrar o fluxo normal de PDF -->
            <div v-else>
              <div v-if="carregandoPDF" class="flex-1 flex items-center justify-center">
                <div class="text-center">
                  <svg class="animate-spin h-8 w-8 mx-auto mb-4 text-blue-600" xmlns="http://www.w3.org/2000/svg"
                    fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                    </path>
                  </svg>
                  <p class="text-gray-600 dark:text-gray-400">Carregando PDF do laudo...</p>
                </div>
              </div>

              <div v-else-if="erroPDF" class="flex-1 flex items-center justify-center">
                <div class="text-center max-w-md mx-auto">
                  <div class="mb-6">
                    <div class="w-20 h-20 mx-auto relative">
                      <div class="absolute inset-0 rounded-full bg-gradient-to-r from-amber-400 to-orange-500 opacity-20 animate-pulse"></div>
                      <div class="absolute inset-2 rounded-full bg-white dark:bg-gray-800 flex items-center justify-center">
                        <svg class="w-8 h-8 text-amber-600 dark:text-amber-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                        </svg>
                      </div>
                    </div>
                  </div>
                  
                  <div class="space-y-3">
                    <h3 class="text-lg font-medium text-gray-900 dark:text-white flex items-center justify-center gap-2">
                      <svg class="w-5 h-5 text-amber-600 dark:text-amber-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                      </svg>
                      PDF Indisponível
                    </h3>
                    
                    <div class="bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg p-4">
                      <p class="text-sm text-amber-800 dark:text-amber-200 leading-relaxed">
                        {{ erroPDF }}
                      </p>
                    </div>
                    
                    <div class="text-xs text-gray-500 dark:text-gray-400 space-y-1">
                      <p>• Leve em consideração o tempo de entrega do exame</p>
                      <p>• Entre em contato com a clínica se o problema persistir</p>
                    </div>
                  </div>
                  
                  <div class="mt-6 space-y-2">
                    <button @click="fecharModal"
                      class="w-full px-4 py-2 bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-800 dark:text-white rounded-md text-sm transition-colors">
                      Fechar
                    </button>
                  </div>
                </div>
              </div>

              <div v-else-if="pdfUrl" class="flex-1 border rounded-md overflow-hidden" style="min-height: 600px;">
                <PDFViewer :pdf-url="pdfUrl" :auto-load="true" @loaded="onPDFLoaded" @error="onPDFError"
                  @page-changed="onPDFPageChanged" class="w-full h-full" />
              </div>

              <div v-else class="flex-1 flex items-center justify-center">
                <div class="text-center">
                  <svg class="h-8 w-8 mx-auto mb-4 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  <p class="text-gray-500 dark:text-gray-400">Nenhum laudo disponível para visualização</p>
                </div>
              </div>
            </div>
          </div>



          <!-- Botões de ação - SEMPRE VISÍVEIS -->
          <div class="flex-shrink-0 pt-4 border-t dark:border-gray-700 space-y-3 bg-white dark:bg-gray-800 sticky bottom-0">
            <!-- Linha de Ações -->
            <div class="flex justify-between items-center">
              <!-- Ações Secundárias (Esquerda) -->
              <div v-if="isMedico" class="flex items-center space-x-2">
                <button v-if="podeEditar" @click="salvarRascunho" :disabled="salvandoLaudo"
                  class="px-3 py-2 bg-blue-100 hover:bg-blue-200 dark:bg-blue-900 dark:hover:bg-blue-800 text-blue-800 dark:text-blue-200 rounded-md text-sm disabled:opacity-50 flex items-center gap-2 transition-colors"
                  title="Salvar alterações sem finalizar">
                  <Save class="h-4 w-4" />
                  <span>{{ salvandoLaudo ? 'Salvando...' : 'Salvar' }}</span>
                </button>



                <button v-if="adendoPendente && laudoAtual?.status !== 'REVIEWED'" @click="finalizarAdendo" :disabled="salvandoAdendo"
                  class="px-3 py-2 bg-orange-600 hover:bg-orange-700 text-white rounded-md text-sm flex items-center gap-2 transition-colors disabled:opacity-50"
                  title="Finalizar e salvar o adendo atual">
                  <svg v-if="salvandoAdendo" class="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                    </path>
                  </svg>
                  <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>{{ salvandoAdendo ? 'Finalizando...' : 'Finalizar Adendo' }}</span>
                </button>



                <!-- Exportar -->
                <div class="relative">
                  <button @click="mostrarExportOptions = !mostrarExportOptions"
                    class="px-3 py-2 bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-800 dark:text-white rounded-md text-sm flex items-center gap-2 transition-colors"
                    title="Exportar o laudo em diferentes formatos">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                      stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    <span>Exportar</span>
                  </button>
                  <div v-if="mostrarExportOptions"
                    class="absolute bottom-full left-0 mb-2 w-40 bg-white dark:bg-gray-700 rounded-md shadow-lg z-10 border dark:border-gray-600">
                    <div class="py-1">
                      <button v-for="formato in formatosExportacao" :key="formato.id" @click="exportarLaudo(formato.id)"
                        class="block w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-600">
                        {{ formato.nome }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Ações Principais (Direita) -->
              <div class="flex items-center space-x-2">
                <!-- Botão de reconvocar paciente (apenas para o médico que iniciou o laudo) -->


                <!-- Botão de download do PDF para usuários não médicos -->
                <button v-if="!isMedico && pdfUrl && laudoAtual?.status !== 'PENDING'" @click="downloadPDF"
                  class="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md text-sm font-medium flex items-center gap-2 transition-colors"
                  title="Baixar PDF do laudo">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  <span>Baixar PDF</span>
                </button>

                <!-- Botão de Revisar Laudo (apenas para médicos com permissão e não sendo o emissor) -->
                <button v-if="podeRevisar && isMedico && laudoAtual && laudoAtual.status === 'COMPLETED' && !(activeTab === 'revisao' && notasRevisao.replace(/<[^>]*>/g, '').trim())" @click="activeTab = 'revisao'"
                  class="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-md text-sm font-medium flex items-center gap-2 transition-colors"
                  title="Revisar o laudo finalizado">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                  <span>Revisar Laudo</span>
                </button>

                <!-- Botão de Finalizar Revisão (substitui o botão de revisar quando há conteúdo) -->
                <button v-if="podeRevisar && isMedico && laudoAtual && laudoAtual.status === 'COMPLETED' && activeTab === 'revisao' && notasRevisao.replace(/<[^>]*>/g, '').trim()" @click="confirmarRevisao" :disabled="revisandoLaudo"
                  class="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-md text-sm font-medium flex items-center gap-2 transition-colors disabled:opacity-50"
                  title="Finalizar e salvar a revisão do laudo">
                  <svg v-if="revisandoLaudo" class="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                    </path>
                  </svg>
                  <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>{{ revisandoLaudo ? 'Finalizando...' : 'Finalizar Revisão' }}</span>
                </button>

                <button v-if="podeAssinar && isMedico" @click="abrirModalAssinarEFinalizar"
                  :disabled="assinandoLaudo || !conteudoLaudo.trim()"
                  class="px-4 py-2 bg-teal-600 hover:bg-teal-700 text-white rounded-md text-sm font-medium disabled:opacity-50 flex items-center gap-2 transition-colors"
                  title="Assinar e finalizar o laudo em uma única etapa">
                  <svg v-if="assinandoLaudo" class="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                    </path>
                  </svg>
                  <CheckCheck v-else class="h-5 w-5" />
                  <span>{{ assinandoLaudo ? 'Processando...' : 'Assinar e Finalizar' }}</span>
                </button>
              </div>
            </div>

            <!-- Informação de permissões -->
            <div v-if="!isMedico && laudoAtual"
              class="text-xs text-center text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/20 p-2 rounded-md">
              <span>Você está visualizando o laudo em modo somente leitura. Apenas médicos podem editar laudos.</span>
            </div>
            <div v-else-if="!podeEditar && laudoAtual && isMedico"
              class="text-xs text-center text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/20 p-2 rounded-md">
              <span v-if="laudoAtual.status === 'IN_PROGRESS' && workflowInfo.drafted_by">
                Este laudo está sendo editado por <strong>{{ workflowInfo.drafted_by.name }}</strong>.
              </span>
              <span v-else-if="laudoAtual.status === 'COMPLETED' && !podeAdicionarAdendo">
                Laudo finalizado. Apenas o autor pode adicionar adendos ou aguarda revisão.
              </span>
              <span v-else-if="laudoAtual.status === 'REVIEWED'">
                Laudo revisado e bloqueado para edição. Não é possível adicionar adendos após a revisão.
              </span>
              <span v-else>
                Você não tem permissão para editar este laudo no estado atual.
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>





  <!-- Modal de Assinatura -->
  <div v-if="mostrarModalAssinatura"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center modal-assinatura"
    style="z-index: 99999;">
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow-lg w-96 max-w-full mx-4">
      <div class="px-6 py-4 border-b dark:border-gray-700">
        <h3 class="text-lg font-bold text-gray-800 dark:text-white">
          {{ acaoAssinatura === 'sign_and_finalize' ? 'Assinatura Digital' : 
             acaoAssinatura === 'finalizar_adendo' ? 'Confirmar Adendo' : 
             acaoAssinatura === 'finalizar_revisao' ? 'Confirmar Revisão' : 'Confirmação' }}
        </h3>
      </div>
      <div class="p-6">
        <div class="mb-4">
          <div class="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-md p-4 mb-4">
            <div class="flex items-start">

              <div class="text-sm text-blue-800 dark:text-blue-200">
                <p v-if="acaoAssinatura === 'sign_and_finalize'">
                  A assinatura digital confirma a autenticidade e integridade do laudo médico, tendo validade legal.
                </p>
                <p v-else-if="acaoAssinatura === 'finalizar_adendo'">
                  A confirmação com senha garante que apenas o médico autorizado pode finalizar o adendo ao laudo.
                </p>
                <p v-else-if="acaoAssinatura === 'finalizar_revisao'">
                  A confirmação com senha garante que apenas o médico revisor pode finalizar a revisão do laudo.
                </p>
                <p v-else>
                  Confirmação de segurança para ações críticas no laudo médico.
                </p>
              </div>
            </div>
          </div>

          <div class="space-y-3">
            <!-- Campo de e-mail oculto para evitar preenchimento automático em outros campos -->
            <input type="email" style="display: none;" autocomplete="username" />
            
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Senha de confirmação:
              </label>
              <input v-model="senhaAssinatura" type="password"
                class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                placeholder="Digite sua senha para confirmar" 
                autocomplete="current-password"
                data-form-type="password"
                required />
            </div>

            <div v-if="acaoAssinatura === 'sign_and_finalize'">
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Observações sobre a assinatura (opcional):
              </label>
              <textarea v-model="observacoesAssinatura"
                class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                rows="3" placeholder="Observações adicionais sobre a assinatura..."></textarea>
            </div>
          </div>
        </div>

        <div class="flex justify-end space-x-2">
          <button @click="cancelarAssinatura"
            class="px-4 py-2 bg-gray-300 hover:bg-gray-400 text-gray-800 rounded-md text-sm">
            Cancelar
          </button>
          <button @click="confirmarAssinatura" :disabled="assinandoLaudo || !senhaAssinatura.trim()"
            class="px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-md text-sm disabled:opacity-50 flex items-center gap-2">
            <svg v-if="assinandoLaudo" class="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none"
              viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
              </path>
            </svg>
            {{ assinandoLaudo ? 'Processando...' : 
               acaoAssinatura === 'sign_and_finalize' ? 'Confirmar Assinatura' :
               acaoAssinatura === 'finalizar_adendo' ? 'Confirmar Adendo' :
               acaoAssinatura === 'finalizar_revisao' ? 'Confirmar Revisão' : 'Confirmar' }}
          </button>
        </div>
      </div>
    </div>
  </div>



  <!-- BannerMessage para notificações -->
  <BannerMessage
    v-if="showBannerMessage"
    :type="bannerType"
    :message="bannerMessage"
    @close="showBannerMessage = false"
    style="z-index: 999999;"
  />
</template>

<script setup>
import { ref, computed, watch, defineProps, defineEmits, onMounted, onUnmounted, nextTick } from 'vue';
import { X, History, FileEdit, ShieldCheck, ScanEye, Signature, Send, Circle, FileText, Save, CheckCheck, Clock, FileText as FileTextIcon, CheckCircle, Eye, Truck, XCircle, AlertTriangle } from 'lucide-vue-next';
import { QuillEditor } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import medicalReportsService from '@/services/medicalReportsService';
import scheduleService from '@/services/scheduleService';
import { useUserStore } from '@/stores/userStore';
import PDFViewer from './PDFViewer.vue';
import BannerMessage from '@/components/BannerMessage.vue';

import RecallPatientButton from '@/components/RecallPatientButton.vue';
import apiClient from '@/services/authService';

// Props
const props = defineProps({
  isVisible: {
    type: Boolean,
    default: false
  },
  paciente: {
    type: Object,
    default: null
  },
  // [NOVO] Modo painel lateral (não modal)
  modoPainel: {
    type: Boolean,
    default: false
  },
  // [NOVO] Modo popup (oculta o visualizador DICOM)
  modoPopup: {
    type: Boolean,
    default: false
  }
});

// Emits
const emit = defineEmits(['close', 'laudo-salvo', 'laudo-finalizado', 'laudo-revisado', 'adendo-adicionado', 'laudo-assinado', 'paciente-atualizado', 'dados-paciente-carregados']);

// Estado reativo
const activeTab = ref('laudo');
const conteudoLaudo = ref('');
const novoAdendoConteudo = ref('');
const notasRevisao = ref('');
const senhaAssinatura = ref('');
const observacoesAssinatura = ref('');
const mascaraSelecionada = ref('');
const mascaras = ref([]);
const carregandoMascaras = ref(false);
const salvandoLaudo = ref(false);
const assinandoLaudo = ref(false);
const revisandoLaudo = ref(false);
const salvandoAdendo = ref(false);
const mostrarModalAssinatura = ref(false);
const acaoAssinatura = ref('');
const laudoAtual = ref(null);
const serviceConfig = ref(null);
const hasPrintSeries = ref(false);
const canLaudoWithoutPrintSeries = ref(true);

// Estados de loading
const carregandoLaudo = ref(false);

// Estados específicos do workflow
const statusLaudo = ref('pendente');
const timelineLaudo = ref([]);
const mostrarExportOptions = ref(false);
const ultimoSalvamento = ref('');
const ultimoPacienteCarregado = ref(null);
const showBannerMessage = ref(false);
const bannerMessage = ref('');
const bannerType = ref('error');

// Variáveis para auto-save
const autoSaveTimer = ref(null);
const salvandoAutomaticamente = ref(false);

// Variáveis para avisos de agendamento
const mostrarAvisoAgendamento = ref(false);
const mensagemAvisoAgendamento = ref('');

// Variáveis para timeline
const mostrarTimeline = ref(false);



// Estados para reconvocação

// Variáveis para processamento de recall

// Referências para editores Quill
const quillEditor = ref(null);
const quillAdendoEditor = ref(null);

// Função para exibir banners
const showBanner = (type, message) => {
  bannerType.value = type;
  bannerMessage.value = message;
  showBannerMessage.value = true;
};
const appointmentExists = ref(false);
const currentAppointment = ref(null);

// [NOVO] Função para verificar se o agendamento existe
const checkAppointmentExists = async () => {
    if (!props.paciente?.numAcesso) {
        appointmentExists.value = false;
        return;
    }

    try {
        await scheduleService.getAppointmentByAccessionNumber(props.paciente.numAcesso);
        appointmentExists.value = true;
        mostrarAvisoAgendamento.value = false; // Garante que o aviso é escondido se o agendamento for encontrado
    } catch (error) {
        appointmentExists.value = false;
        
        // [NOVO] Ativar o aviso quando o agendamento não for encontrado
        mensagemAvisoAgendamento.value = `Não foi encontrado agendamento para o exame com número de acesso: ${props.paciente?.numAcesso || 'N/A'}. \n\nPara criar um laudo, é necessário que o exame esteja agendado no sistema. Entre em contato com a administração para verificar o status do agendamento.`;
        mostrarAvisoAgendamento.value = true;
    }
};



// Configuração do editor Quill
const editorOptions = ref({
  theme: 'snow',
  placeholder: 'Digite o laudo médico aqui...',
  bounds: document.body,
  debug: false,
  modules: {
    toolbar: {
      container: [
        [{ 'header': [1, 2, 3, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'indent': '-1' }, { 'indent': '+1' }],
        [{ 'align': [] }],
        ['blockquote', 'code-block'],
        ['link'],
        ['clean']
      ],
      handlers: {
        // Handlers customizados se necessário
      }
    },
    history: {
      delay: 2000,
      maxStack: 500,
      userOnly: true
    }
  },
  formats: [
    'header', 'bold', 'italic', 'underline', 'strike',
    'color', 'background', 'list', 'bullet', 'indent',
    'align', 'blockquote', 'code-block', 'link'
  ]
});

// Mapeamento de ícones para status
const statusIcons = {
  'Clock': Clock,
  'FileTextIcon': FileTextIcon,
  'FileEdit': FileEdit,
  'CheckCircle': CheckCircle,
  'Eye': Eye,
  'Truck': Truck,
  'XCircle': XCircle,
  'Circle': Circle,
  'AlertTriangle': AlertTriangle
};

// Mapeamento de cores para status - Paleta Moderna 2024
const statusColors = {
  'PENDING': { bg: '#fef9c3', border: '#eab308', text: '#a16207' }, // Amarelo limão
  'DRAFT': { bg: '#e0e7ff', border: '#6366f1', text: '#3730a3' }, // Índigo
  'IN_PROGRESS': { bg: '#fef3c7', border: '#f59e0b', text: '#92400e' }, // Âmbar
  'COMPLETED': { bg: '#d1fae5', border: '#10b981', text: '#047857' }, // Esmeralda
  'REVIEWED': { bg: '#f3e8ff', border: '#8b5cf6', text: '#5b21b6' }, // Violeta
  'DELIVERED': { bg: '#dbeafe', border: '#3b82f6', text: '#1e40af' }, // Azul
  'CANCELLED': { bg: '#fee2e2', border: '#ef4444', text: '#b91c1c' }, // Vermelho
  'RECALLED': { bg: '#fed7aa', border: '#f97316', text: '#ea580c' } // Laranja
};

const getStatusStyle = (status) => {
  const colors = statusColors[status] || statusColors['PENDING'];
  return {
    backgroundColor: colors.bg,
    borderColor: colors.border,
    color: colors.text,
    borderWidth: '1px',
    borderStyle: 'solid'
  };
};

// Formatos de exportação
const formatosExportacao = ref([
  { id: 'pdf', nome: 'PDF' },
  { id: 'txt', nome: 'Texto (TXT)' },
  { id: 'docx', nome: 'Word (DOCX)' }
]);

// Computed
const appointmentId = computed(() => {
  const id = props.paciente?.appointmentId || props.paciente?.id;

  // Verificar se o ID é válido (não undefined, null, ou string vazia)
  if (id && id !== 'undefined' && id !== 'null' && id !== '') {
    return id;
  }

  return null;
});

const contadorCaracteres = computed(() => {
  if (!conteudoLaudo.value) return 0;
  // Remove HTML tags para contar apenas texto
  const textOnly = conteudoLaudo.value.replace(/<[^>]*>/g, '');
  return textOnly.length;
});

// [NOVO] Computed para detectar tema escuro
const isDarkMode = computed(() => {
  return document.documentElement.classList.contains('dark');
});

// [NOVO] Computed para classes condicionais do painel
const panelClasses = computed(() => {
  if (!props.modoPainel) return '';
  return isDarkMode.value ? 'dark' : '';
});

// ================================
// COMPUTED PROPERTIES DO WORKFLOW
// ================================

const workflowInfo = computed(() => {
  return laudoAtual.value?.workflow || {};
});

// ================================
// COMPUTED PROPERTIES DE RECONVOCAÇÃO
// ================================

const recallInfo = computed(() => {
  return laudoAtual.value?.recall_info || null;
});

const isRecallBlocked = computed(() => {
  return recallInfo.value?.is_blocked || false;
});

const recallStatus = computed(() => {
  return recallInfo.value?.status || null;
});

const recallReason = computed(() => {
  return recallInfo.value?.reason || '';
});

const recallDescription = computed(() => {
  return recallInfo.value?.description || '';
});

const recallBlockedAt = computed(() => {
  return recallInfo.value?.blocked_at || null;
});

// Verifica se pode reconvocar (não há reconvocação pendente ou agendada)
const canRecall = computed(() => {
  if (!isRecallBlocked.value) return true;
  
  // Se está bloqueado, verifica o status
  const status = recallStatus.value;
  return !status || status === 'completed' || status === 'cancelled';
});

// Verifica se pode laudar (não está bloqueado por reconvocação)
const canEditReport = computed(() => {
  return !isRecallBlocked.value;
});

// Verifica se pode realizar qualquer ação de laudo
const canPerformLaudoActions = computed(() => {
  return canEditReport.value;
});

const podeEditar = computed(() => {
  return medicalReportsService.podeEditar(laudoAtual.value) && canPerformLaudoActions.value;
});

const podeAssinar = computed(() => {
  return medicalReportsService.podeAssinar(laudoAtual.value) && canPerformLaudoActions.value;
});

const podeRevisar = computed(() => {
  return medicalReportsService.podeRevisar(laudoAtual.value) && canPerformLaudoActions.value;
});

const podeAdicionarAdendo = computed(() => {
  return medicalReportsService.podeAdicionarAdendo(laudoAtual.value) && canPerformLaudoActions.value && laudoAtual.value?.status !== 'REVIEWED';
});

const laudoCompletoParaExibicao = computed(() => {
  if (!laudoAtual.value) return '';
  const content = laudoAtual.value.content || '';
  const addenda = laudoAtual.value.addenda || '';
  const reviewNotes = laudoAtual.value.workflow?.review_notes || '';

  let fullContent = content + addenda;

  // Adicionar conteúdo da revisão se existir
  if (reviewNotes) {
    fullContent += `<div class="mt-4 p-3 bg-purple-50 dark:bg-purple-900/20 border border-purple-200 dark:border-purple-800 rounded-md">`;
    fullContent += `<div class="flex items-start mb-2">`;
    fullContent += `<div class="text-sm text-purple-800 dark:text-purple-200">`;
    fullContent += `<p class="font-medium">Revisão do Laudo</p>`;
    fullContent += `<p class="text-xs text-purple-600 dark:text-purple-300">por ${laudoAtual.value.workflow?.reviewed_by?.name || 'Revisor'}</p>`;
    fullContent += `</div>`;
    fullContent += `</div>`;
    fullContent += `<div class="text-sm text-purple-700 dark:text-purple-300">${reviewNotes}</div>`;
    fullContent += `</div>`;
  }

  return fullContent;
});

// [NOVO] Computed para exibir o botão de finalizar adendo
const adendoPendente = computed(() => {
  return (
    activeTab.value === 'adendo' &&
    novoAdendoConteudo.value.replace(/<[^>]*>/g, '').trim().length > 0 &&
    podeAdicionarAdendo.value &&
    !salvandoAdendo.value
  );
});




// Watchers otimizados para funcionar em ambos os modos (modal e painel)
watch(() => props.isVisible, async (novoValor) => {
  if (novoValor && props.paciente && !carregandoLaudo.value) {
    // Verificar se já não carregamos este paciente
    const pacienteKey = props.paciente?.numAcesso || props.paciente?.id || 'unknown';

    if (pacienteKey !== ultimoPacienteCarregado.value) {
      ultimoPacienteCarregado.value = pacienteKey;
      await carregarDadosIniciais();
    }
  }
});

watch(() => props.paciente, async (novoPaciente, pacienteAnterior) => {
  // Carregar se o componente estiver visível (modal) OU se estiver no modo painel OU popup
  if (novoPaciente && (props.isVisible || props.modoPainel || props.modoPopup) && !carregandoLaudo.value) {
    const novoPacienteKey = novoPaciente?.numAcesso || novoPaciente?.appointmentId || novoPaciente?.id || 'unknown';
    const pacienteAnteriorKey = pacienteAnterior?.numAcesso || pacienteAnterior?.appointmentId || pacienteAnterior?.id || 'unknown';

    // Só carregar se realmente mudou o paciente
    if (novoPacienteKey && novoPacienteKey !== pacienteAnteriorKey && novoPacienteKey !== ultimoPacienteCarregado.value) {
      ultimoPacienteCarregado.value = novoPacienteKey;
      await carregarDadosIniciais();
    }
  }
});

// Watcher específico para modo painel
watch(() => props.modoPainel, async (novoValor) => {
  if (novoValor && props.paciente && !carregandoLaudo.value) {
    const pacienteKey = props.paciente?.numAcesso || props.paciente?.appointmentId || props.paciente?.id || 'unknown';

    if (pacienteKey !== ultimoPacienteCarregado.value) {
      ultimoPacienteCarregado.value = pacienteKey;
      await carregarDadosIniciais();
    }
  }
});

// Watcher específico para modo popup
watch(() => props.modoPopup, async (novoValor) => {
  if (novoValor && props.paciente && !carregandoLaudo.value) {
    const pacienteKey = props.paciente?.numAcesso || props.paciente?.appointmentId || props.paciente?.id || 'unknown';

    if (pacienteKey !== ultimoPacienteCarregado.value) {
      ultimoPacienteCarregado.value = pacienteKey;
      await carregarDadosIniciais();
    }
  }
});

// [NOVO] Watcher para verificar agendamento quando o paciente muda
watch(() => props.paciente?.numAcesso, async (newAccession) => {
    if (newAccession) {
        await checkAppointmentExists();
    } else {
        appointmentExists.value = false;
    }
}, { immediate: true });

// Variável para o observer
let themeObserver = null;

// Observar mudanças na classe 'dark' do documento
onMounted(() => {
  // Criar o observer apenas quando o componente estiver montado
  themeObserver = new MutationObserver(() => {
    // O CSS agora cuida automaticamente das cores do editor
    // Não precisamos mais forçar cores manualmente
  });

  themeObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class']
  });

  // [NOVO] Carregar dados se estiver no modo painel ou popup e tiver paciente
  if ((props.modoPainel || props.modoPopup) && props.paciente && !carregandoLaudo.value) {
    const pacienteKey = props.paciente?.numAcesso || props.paciente?.appointmentId || props.paciente?.id || 'unknown';
    if (pacienteKey !== ultimoPacienteCarregado.value) {
      ultimoPacienteCarregado.value = pacienteKey;
      carregarDadosIniciais();
    }
  }
});

// Cleanup no unmount
onUnmounted(() => {
  if (autoSaveTimer.value) {
    clearTimeout(autoSaveTimer.value);
    autoSaveTimer.value = null;
  }
  if (themeObserver) {
    themeObserver.disconnect();
    themeObserver = null;
  }

  // Limpar URL do PDF
  pdfUrl.value = '';
});

// Função para processar placeholders da máscara
const processarPlaceholders = (conteudo) => {
  if (!conteudo) return conteudo;

  console.log('Processando placeholders para conteúdo:', conteudo);

  let conteudoProcessado = conteudo;

  // Placeholders disponíveis para laudos médicos
  const placeholders = {
    // Dados do paciente
    '{paciente}': props.paciente?.nome || '[Nome do Paciente]',
    '{idade}': calcularIdade(),
    '{sexo}': props.paciente?.sexo || '[Sexo]',
    '{cpf}': props.paciente?.cpf || '[CPF]',

    // Dados do exame
    '{data}': formatarData(props.paciente?.data),
    '{numero_exame}': props.paciente?.numero || '[Número do Exame]',
    '{tipo_exame}': props.paciente?.exame || '[Tipo de Exame]',
    '{modalidade}': props.paciente?.mod || '[Modalidade]',
    '{numero_acesso}': props.paciente?.numAcesso || '[Número de Acesso]',

    // Dados do médico
    '{medico}': props.paciente?.medRef || '[Médico Solicitante]',
    '{medico_radiologista}': '[Médico Radiologista]', // Seria do usuário logado

    // Data/hora atual
    '{data_atual}': new Date().toLocaleDateString('pt-BR'),
    '{hora_atual}': new Date().toLocaleTimeString('pt-BR'),

    // Seções padrão de laudo
    '{historia_clinica}': '<strong>HISTÓRIA CLÍNICA:</strong><br>',
    '{tecnica}': '<strong>TÉCNICA:</strong><br>',
    '{achados}': '<strong>ACHADOS:</strong><br>',
    '{conclusao}': '<strong>CONCLUSÃO:</strong><br>',
    '{observacoes}': '<strong>OBSERVAÇÕES:</strong><br>'
  };

  console.log('Placeholders disponíveis:', placeholders);

  // Aplicar todos os placeholders
  Object.entries(placeholders).forEach(([placeholder, valor]) => {
    try {
      const regex = new RegExp(placeholder.replace(/[{}]/g, '\\$&'), 'g');
      conteudoProcessado = conteudoProcessado.replace(regex, valor);
    } catch (error) {
      console.error(`Erro ao processar placeholder ${placeholder}:`, error);
    }
  });

  // Converter quebras de linha para HTML
  conteudoProcessado = processarQuebrasDeLinha(conteudoProcessado);

  console.log('Conteúdo processado:', conteudoProcessado);

  return conteudoProcessado;
};

// Função auxiliar para calcular idade
const calcularIdade = () => {
  if (!props.paciente?.dataNasc) return '[Idade]';

  try {
    const hoje = new Date();
    const nascimento = new Date(props.paciente.dataNasc);
    
    // Verificar se a data é válida
    if (isNaN(nascimento.getTime())) {
      return '[Idade]';
    }
    
    let idade = hoje.getFullYear() - nascimento.getFullYear();
    const mes = hoje.getMonth() - nascimento.getMonth();

    if (mes < 0 || (mes === 0 && hoje.getDate() < nascimento.getDate())) {
      idade--;
    }

    return `${idade} anos`;
  } catch (error) {
    console.error('Erro ao calcular idade:', error);
    return '[Idade]';
  }
};

// Função auxiliar para formatar data (removida - usando a versão mais completa acima)

// Função auxiliar para processar quebras de linha
const processarQuebrasDeLinha = (conteudo) => {
  try {
    // Converter \n\n em quebras de parágrafo
    let processado = conteudo.replace(/\n\n/g, '</p><p>');
    // Converter \n simples em quebras de linha
    processado = processado.replace(/\n/g, '<br>');

    // Envolver em parágrafos se necessário
    if (!processado.includes('<p>') && !processado.includes('<br>')) {
      processado = `<p>${processado}</p>`;
    } else if (!processado.startsWith('<p>') && processado.includes('</p>')) {
      processado = `<p>${processado}`;
    } else if (!processado.includes('<p>')) {
      processado = `<p>${processado}</p>`;
    }

    return processado;
  } catch (error) {
    console.error('Erro ao processar quebras de linha:', error);
    return conteudo;
  }
};

// ================================
// MÉTODOS DE FORMATAÇÃO E UTILITÁRIOS
// ================================

const formatarData = (data) => {
  if (!data) return '';
  try {
    const dataObj = new Date(data);
    
    // Verificar se a data é válida
    if (isNaN(dataObj.getTime())) {
      return data;
    }
    
    return new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }).format(dataObj);
  } catch (error) {
    console.error('Erro ao formatar data:', error);
    return data;
  }
};

const formatarDataExame = (data) => {
  if (!data) return 'Data não disponível';
  try {
    const dataObj = new Date(data);

    // Verificar se a data é válida
    if (isNaN(dataObj.getTime())) {
      return 'Data inválida';
    }

    // Formatar data e hora
    const dataFormatada = new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    }).format(dataObj);


    return `${dataFormatada}`;
  } catch (error) {
    return 'Data inválida';
  }
};

const formatDateBR = (dateString) => {
  if (!dateString) return '';
  
  try {
    const [year, month, day] = dateString.split('-');
    return `${day}/${month}/${year}`;
  } catch (error) {
    return dateString; // Retorna original se não conseguir formatar
  }
};

const getTimelineIcon = (type) => {
  const icons = {
    'draft': { icon: FileEdit, bgClass: 'bg-blue-100 dark:bg-blue-900', iconClass: 'text-blue-600 dark:text-blue-300' },
    'finalize': { icon: ShieldCheck, bgClass: 'bg-green-100 dark:bg-green-900', iconClass: 'text-green-600 dark:text-green-300' },
    'review': { icon: ScanEye, bgClass: 'bg-purple-100 dark:bg-purple-900', iconClass: 'text-purple-600 dark:text-purple-300' },
    'sign': { icon: Signature, bgClass: 'bg-indigo-100 dark:bg-indigo-900', iconClass: 'text-indigo-600 dark:text-indigo-300' },
    'deliver': { icon: Send, bgClass: 'bg-cyan-100 dark:bg-cyan-900', iconClass: 'text-cyan-600 dark:text-cyan-300' },
    'addenda': { icon: FileText, bgClass: 'bg-orange-100 dark:bg-orange-900', iconClass: 'text-orange-600 dark:text-orange-300' },
    'recall_blocked': { icon: AlertTriangle, bgClass: 'bg-amber-100 dark:bg-amber-900', iconClass: 'text-amber-600 dark:text-amber-300' },
    'recall_scheduled': { icon: Clock, bgClass: 'bg-blue-100 dark:bg-blue-900', iconClass: 'text-blue-600 dark:text-blue-300' },
    'recall_completed': { icon: CheckCircle, bgClass: 'bg-green-100 dark:bg-green-900', iconClass: 'text-green-600 dark:text-green-300' },
    'recall_cancelled': { icon: XCircle, bgClass: 'bg-red-100 dark:bg-red-900', iconClass: 'text-red-600 dark:text-red-300' },
    'default': { icon: Circle, bgClass: 'bg-gray-100 dark:bg-gray-600', iconClass: 'text-gray-500 dark:text-gray-300' }
  };
  return icons[type] || icons['default'];
};

// ================================
// MÉTODOS DE CONTROLE DO EDITOR
// ================================

const onEditorReady = (quill) => {
  // Aguardar um tick para garantir que o DOM está estável
  nextTick(() => {
    if (quill && quill.root) {
      try {
        // Se há conteúdo para carregar, aplicar após um pequeno delay
        if (conteudoLaudo.value) {
          setTimeout(() => {
            if (quill.root) {
              quill.root.innerHTML = conteudoLaudo.value;
              quill.update();
              // Forçar atualização do scroll após carregar conteúdo
              setTimeout(() => {
                if (quill.container) {
                  quill.container.style.overflowY = 'auto';
                  quill.container.style.maxHeight = 'none';
                }
              }, 200);
            }
          }, 100);
        }
      } catch (error) {
        // Erro silencioso ao configurar editor inicial
      }
    }
  });
};

const onContentChange = () => {
  // Desabilitar salvamento automático se o laudo não for mais editável
  if (!podeEditar.value) {
    return;
  }

  // Agendar salvamento automático
  if (autoSaveTimer.value) {
    clearTimeout(autoSaveTimer.value);
  }

  // Sempre agendar o salvamento se houver edição, mesmo para laudos novos.
  autoSaveTimer.value = setTimeout(() => {
    salvarAutomaticamente();
  }, 3000); // 3 segundos após a última mudança

  // Garantir que o editor tenha scroll adequado após mudanças
  nextTick(() => {
    if (quillEditor.value?.getQuill) {
      const quill = quillEditor.value.getQuill();
      if (quill && quill.container) {
        quill.container.style.overflowY = 'auto';
        quill.container.style.maxHeight = 'none';
      }
    }
  });
};

const salvarAutomaticamente = async () => {
  // Apenas não salvar se já houver uma operação de salvamento em andamento.
  if (salvandoLaudo.value) return;

  salvandoAutomaticamente.value = true;
  salvandoLaudo.value = true;
  try {
    await salvarLaudo(statusLaudo.value, false); // false = não emitir eventos
    ultimoSalvamento.value = new Date().toLocaleTimeString();
  } catch (error) {
    // Erro silencioso no salvamento automático
  } finally {
    salvandoLaudo.value = false;
    salvandoAutomaticamente.value = false;
  }
};

const carregarDadosIniciais = async () => {
  const [laudoResult, mascarasResult] = await Promise.allSettled([
    carregarLaudo(),
    carregarMascaras(),
  ]);

  if (laudoResult.status === 'rejected') {
    console.error('LaudoModal: Falha ao carregar o laudo:', laudoResult.reason);
  }
  if (mascarasResult.status === 'rejected') {
    console.error('LaudoModal: Falha ao carregar as máscaras:', mascarasResult.reason);
  }

  // [NOVO] Verificar se o agendamento existe após carregar os dados
  if (props.paciente?.numAcesso) {
    await checkAppointmentExists();
    await abrirModalReconvocar(); // Buscar dados do agendamento para o componente
  }
};

const carregarLaudoComId = async (id) => {
  carregandoLaudo.value = true;
  try {
    const response = await medicalReportsService.obterLaudoPorAgendamento(id);
    
    if (response.data) {
      laudoAtual.value = response.data;
      statusLaudo.value = medicalReportsService.mapearStatusDaAPI(response.data.status);
      
      // Carregar timeline do laudo apenas para médicos
      if (isMedico.value) {
        timelineLaudo.value = medicalReportsService.obterTimeline(response.data);
      } else {
        timelineLaudo.value = [];
      }
      
      if (response.data.patient && response.data.service) {
        const dadosPaciente = {
          nome: response.data.patient.name || 'Paciente não identificado',
          exame: response.data.service.descricao || response.data.service_name || 'Exame não identificado',
          idPaciente: response.data.patient.id?.toString() || 'ID não disponível',
          numAcesso: response.data.accession_number || props.paciente?.numAcesso,
          data: response.data.exam_date || response.data.created_at || new Date().toISOString(),
          numero: response.data.accession_number || props.paciente?.numero,
          appointmentId: response.data.appointment?.id || response.data.id,
          sexo: response.data.patient.gender || 'N/A',
          dataNasc: response.data.patient.birth_date,
          cpf: response.data.patient.cpf || 'N/A',
          medRef: response.data.appointment?.requesting_doctor?.name || response.data.appointment?.internal_doctor?.name || 'N/A',
          mod: response.data.service.modalidade || response.data.service.mnemonico || 'N/A'
        };
        emit('dados-paciente-carregados', dadosPaciente);
      }
      const fullContent = (response.data.content || '') + (response.data.addenda || '');
      conteudoLaudo.value = fullContent;
      mascaraSelecionada.value = '';
      if (fullContent && isMedico.value) {
        await nextTick();
        if (quillEditor.value?.getQuill) {
          carregarConteudoNoEditor(fullContent, null);
        } else {
          setTimeout(() => {
            if (quillEditor.value?.getQuill) {
              carregarConteudoNoEditor(fullContent, null);
            }
          }, 500);
        }
      }
    } else {
      laudoAtual.value = null;
      conteudoLaudo.value = '';
      statusLaudo.value = 'pendente';
      mascaraSelecionada.value = '';
      timelineLaudo.value = [];
    }
  } catch (error) {
    console.error('LaudoModal: Erro ao carregar laudo:', error);
    if (error.response?.status === 404) {
      mostrarAvisoSemAgendamento();
      return;
    }
    laudoAtual.value = null;
    conteudoLaudo.value = '';
    statusLaudo.value = 'pendente';
    mascaraSelecionada.value = '';
    timelineLaudo.value = [];
  } finally {
    carregandoLaudo.value = false;
  }
};

const carregarLaudo = async () => {
  // Verificar permissão para laudar primeiro (apenas para médicos)
  if (isMedico.value) {
    const podeFazerLaudo = await verificarPermissaoLaudo();
    if (!podeFazerLaudo) {
      showBanner('error', 'Não é possível laudar este exame. É necessário criar uma série de impressão primeiro.');
      return;
    }
  }

  // Verificar se temos appointmentId válido
  if (!appointmentId.value || appointmentId.value === 'undefined' || appointmentId.value === 'null') {
    if (props.paciente?.numAcesso) {
      try {
        const response = await medicalReportsService.buscarAgendamentoPorAccession(props.paciente.numAcesso);
        if (response && response.data && response.data.id) {
          const encontradoAppointmentId = response.data.id;
          await carregarLaudoComId(encontradoAppointmentId);
          return;
        } else {
          mostrarAvisoSemAgendamento();
          return;
        }
      } catch (error) {
        mostrarAvisoSemAgendamento();
        return;
      }
    } else {
      mostrarAvisoSemAgendamento();
      return;
    }
  }
  if (!appointmentId.value || appointmentId.value === 'undefined' || appointmentId.value === 'null') {
    mostrarAvisoSemAgendamento();
    return;
  }
  await carregarLaudoComId(appointmentId.value);
};

const carregarMascaras = async () => {
  carregandoMascaras.value = true;
  try {
    console.log('Carregando máscaras...');
    const response = await medicalReportsService.listarMascaras();

    console.log('Resposta da API de listagem de máscaras:', response);

    // Verificar se a resposta tem dados válidos
    if (response.data && response.data.results) {
      // Estrutura paginada: {count, next_page, previous_page, results}
      console.log('Estrutura paginada detectada');
      mascaras.value = response.data.results.filter(mascara =>
        mascara &&
        typeof mascara === 'object' &&
        mascara.id !== null &&
        mascara.id !== undefined
      );
    } else if (Array.isArray(response.data)) {
      // Array direto
      console.log('Array direto detectado');
      mascaras.value = response.data.filter(mascara =>
        mascara &&
        typeof mascara === 'object' &&
        mascara.id !== null &&
        mascara.id !== undefined
      );
    } else {
      console.log('Nenhuma estrutura válida detectada');
      mascaras.value = [];
    }

    console.log('Máscaras carregadas:', mascaras.value);
  } catch (error) {
    console.error('LaudoModal: Erro ao carregar máscaras:', error);
    console.error('LaudoModal: Status do erro:', error.response?.status);
    console.error('LaudoModal: Mensagem do erro:', error.response?.data);
    mascaras.value = [];

    // Se for erro 403, pode ser problema de permissões
    if (error.response?.status === 403) {
      console.warn('LaudoModal: Erro 403 - Problema de permissões para acessar máscaras');
    }
    // Se for erro 404, pode significar que não há endpoint ainda
    else if (error.response?.status === 404) {
      console.warn('LaudoModal: Endpoint de máscaras retornou 404 - pode não estar implementado');
    }
  } finally {
    carregandoMascaras.value = false;
  }
};

const aplicarMascara = async () => {
  if (!mascaraSelecionada.value) return;

  console.log('Aplicando máscara com ID:', mascaraSelecionada.value);

  carregandoMascaras.value = true;
  try {
    const response = await apiClient.get(`/api/v1/masks/get/${mascaraSelecionada.value}/`);

    console.log('Resposta da API de máscaras:', response);

    const dadosMascara = response.data;
    console.log('Dados da máscara:', dadosMascara);

    if (dadosMascara && (dadosMascara.conteudo || dadosMascara.content)) {
      // Processar placeholders da máscara
      const conteudoMascaraBruto = dadosMascara.conteudo || dadosMascara.content;
      console.log('Conteúdo bruto da máscara:', conteudoMascaraBruto);
      
      const conteudoMascaraProcessado = processarPlaceholders(conteudoMascaraBruto);
      console.log('Conteúdo processado da máscara:', conteudoMascaraProcessado);

      // Se estiver na aba de adendo, aplicar no adendo
      if (activeTab.value === 'adendo') {
        // Se já existe conteúdo no adendo, perguntar se quer substituir
        if (novoAdendoConteudo.value.trim() && !confirm('Isto irá substituir o conteúdo atual do adendo. Deseja continuar?')) {
          mascaraSelecionada.value = '';
          return;
        }

        novoAdendoConteudo.value = conteudoMascaraProcessado;

        // Aguardar próximo tick e forçar atualização do editor de adendo
        await nextTick();
        setTimeout(() => {
          if (quillAdendoEditor.value?.getQuill) {
            try {
              const quill = quillAdendoEditor.value.getQuill();
              if (quill && quill.root) {
                quill.root.innerHTML = conteudoMascaraProcessado;
                try {
                  quill.setSelection(quill.getLength(), 0);
                  quill.focus();
                } catch (focusError) {
                  // Erro silencioso ao focar no editor
                }
              }
            } catch (error) {
              // Erro silencioso ao aplicar máscara no editor de adendo
            }
          }
        }, 100);
      } else {
        // Se estiver na aba do laudo principal (editável)
        if (!podeEditar.value) {
          showBanner('warning', 'Não é possível aplicar máscaras em laudos finalizados. Use a aba de adendo.');
          mascaraSelecionada.value = '';
          return;
        }

        // Se já existe conteúdo, perguntar se quer substituir
        if (conteudoLaudo.value.trim() && !confirm('Isto irá substituir o conteúdo atual. Deseja continuar?')) {
          mascaraSelecionada.value = '';
          return;
        }

        conteudoLaudo.value = conteudoMascaraProcessado;

        // Aguardar próximo tick e forçar atualização do editor
        await nextTick();
        setTimeout(() => {
          if (quillEditor.value?.getQuill) {
            try {
              const quill = quillEditor.value.getQuill();
              if (quill && quill.root) {
                quill.root.innerHTML = conteudoMascaraProcessado;
                try {
                  quill.setSelection(quill.getLength(), 0);
                  quill.focus();
                } catch (focusError) {
                  // Erro silencioso ao focar no editor
                }
              }
            } catch (error) {
              // Erro silencioso ao aplicar máscara no editor
            }
          }
        }, 100);
      }

      // Limpar seleção da máscara após aplicar
      setTimeout(() => {
        mascaraSelecionada.value = '';
      }, 200);
    }
  } catch (error) {
    // Limpar seleção da máscara em caso de erro
    mascaraSelecionada.value = '';

    console.error('Erro ao aplicar máscara:', error);
    console.error('Status do erro:', error.response?.status);
    console.error('Dados do erro:', error.response?.data);

    // Mostrar mensagem de erro específica
    if (error.response?.status === 404) {
      showBanner('warning', 'Máscara não encontrada. Verifique se a máscara ainda existe.');
    } else if (error.response?.status === 403) {
      showBanner('warning', 'Você não tem permissão para acessar esta máscara.');
    } else if (error.response?.status === 401) {
      showBanner('error', 'Sessão expirada. Faça login novamente.');
    } else {
      showBanner('error', 'Erro ao aplicar máscara. Tente novamente.');
    }
  } finally {
    carregandoMascaras.value = false;
  }
};

const salvarLaudo = async (status = null, emitirEventos = true) => {
  if (!appointmentId.value) return;

  salvandoLaudo.value = true;
  
  // Preservar a posição do cursor antes de salvar
  let cursorPosition = null;
  if (quillEditor.value?.getQuill) {
    const quill = quillEditor.value.getQuill();
    if (quill) {
      const range = quill.getSelection();
      if (range) {
        cursorPosition = range.index;
      }
    }
  }
  
  try {
    const statusAPI = status ? medicalReportsService.mapearStatusParaAPI(status) : medicalReportsService.mapearStatusParaAPI(statusLaudo.value);

    const dadosLaudo = {
      content: conteudoLaudo.value,
      status: statusAPI
      // Não enviar mascara_id - máscara é apenas template
    };

    let response;
    if (laudoAtual.value) {
      // Atualizar laudo existente
      response = await medicalReportsService.atualizarLaudo(laudoAtual.value.id, dadosLaudo);
      // Atualizar o laudo atual com a resposta do servidor
      laudoAtual.value = response.data;
    } else {
      // Criar novo laudo
      dadosLaudo.appointment_id = appointmentId.value;
      response = await medicalReportsService.criarLaudo(dadosLaudo);
      laudoAtual.value = response.data;
    }

    if (emitirEventos) {
      emit('laudo-salvo', response.data);
    }

    // Atualizar o conteúdo do editor para refletir o novo estado (original + adendos)
    const fullContent = (laudoAtual.value.content || '') + (laudoAtual.value.addenda || '');
    conteudoLaudo.value = fullContent;
    
    // Se for salvamento automático, não recarregar o editor para manter a posição do cursor
    if (!emitirEventos) {
      // Apenas atualizar o valor interno sem recarregar o editor
      return response.data;
    }
    
    // Para salvamento manual, recarregar o editor e restaurar a posição do cursor
    await carregarConteudoNoEditor(fullContent, cursorPosition);

    return response.data;
  } finally {
    salvandoLaudo.value = false;
  }
};

const salvarRascunho = async () => {
  try {
    // Salvar com status 'IN_PROGRESS' para permitir assinatura
    await salvarLaudo('em_andamento');

    // O laudoAtual.value já foi atualizado pela função salvarLaudo
    ultimoSalvamento.value = new Date().toLocaleTimeString();
  } catch (error) {
    // Erro silencioso ao salvar rascunho
  }
};

// ================================
// MÉTODOS DO WORKFLOW
// ================================

const confirmarRevisao = async () => {
  if (!laudoAtual.value) {
    showBanner('error', 'Nenhum laudo carregado.');
    return;
  }

  // Validar se há conteúdo na revisão
  const revisaoText = notasRevisao.value.replace(/<[^>]*>/g, '').trim();
  if (!revisaoText) {
    showBanner('warning', 'As notas da revisão não podem estar vazias.');
    return;
  }

  // Abrir modal de senha para finalizar revisão
  abrirModalAssinatura('finalizar_revisao');
};

const executarFinalizarRevisao = async () => {
  revisandoLaudo.value = true;
  try {
    const response = await medicalReportsService.revisarLaudo(
      laudoAtual.value.id,
      notasRevisao.value // Enviar o HTML da revisão
    );

    // Atualizar o laudo atual com os dados retornados
    laudoAtual.value = response.data;
    statusLaudo.value = medicalReportsService.mapearStatusDaAPI(response.data.status);

    // Limpar dados e voltar para a aba do laudo
    notasRevisao.value = '';
    activeTab.value = 'laudo';

    emit('laudo-revisado', response.data);

    showBanner('success', 'Laudo revisado com sucesso!');

  } catch (error) {
    const errorMessage = error.response?.data?.detail || 'Erro ao revisar laudo. Tente novamente.';
    showBanner('error', errorMessage);
  } finally {
    revisandoLaudo.value = false;
  }
};

const finalizarAdendo = async () => {
  if (!laudoAtual.value) {
    showBanner('error', 'Nenhum laudo carregado.');
    return;
  }

  // Validação para garantir que o conteúdo do novo adendo não está vazio
  const adendoText = novoAdendoConteudo.value.replace(/<[^>]*>/g, '').trim();
  if (!adendoText) {
    showBanner('warning', 'O conteúdo do adendo não pode estar vazio.');
    return;
  }

  // Abrir modal de senha para finalizar adendo
  abrirModalAssinatura('finalizar_adendo');
};

const executarFinalizarAdendo = async () => {
  salvandoAdendo.value = true;
  try {
    const response = await medicalReportsService.adicionarAdendo(
      laudoAtual.value.id,
      novoAdendoConteudo.value // Enviar o HTML do novo adendo
    );

    // Atualizar o laudo atual com os dados retornados
    laudoAtual.value = response.data;

    emit('adendo-adicionado', response.data);
    showBanner('success', 'Adendo finalizado e salvo com sucesso!');

    // Limpar o editor de adendo e voltar para a aba do laudo
    novoAdendoConteudo.value = '';
    activeTab.value = 'laudo';

  } catch (error) {
    const errorMessage = error.response?.data?.detail || 'Erro ao finalizar adendo. Tente novamente.';
    showBanner('error', errorMessage);
  } finally {
    salvandoAdendo.value = false;
  }
};

const abrirModalAssinatura = (acao) => {
  acaoAssinatura.value = acao;
  mostrarModalAssinatura.value = true;
};

const abrirModalAssinarEFinalizar = () => {
  if (!conteudoLaudo.value.trim()) {
    showBanner('warning', 'O laudo não pode estar vazio para ser assinado e finalizado.');
    return;
  }

  abrirModalAssinatura('sign_and_finalize');
};

const confirmarAssinatura = async () => {
  if (!laudoAtual.value) {
    showBanner('error', 'Nenhum laudo carregado.');
    return;
  }
  if (!senhaAssinatura.value.trim()) {
    showBanner('warning', 'A senha é obrigatória para confirmar a ação.');
    return;
  }

  assinandoLaudo.value = true;
  try {
    if (acaoAssinatura.value === 'sign_and_finalize') {
      // Passo 1: Salvar o conteúdo mais recente antes de assinar.
      await medicalReportsService.atualizarLaudo(laudoAtual.value.id, {
        content: conteudoLaudo.value
      });

      // Passo 2: Chamar o endpoint de assinatura.
      const response = await medicalReportsService.assinarLaudo(
        laudoAtual.value.id,
        {
          password: senhaAssinatura.value,
          signature_notes: observacoesAssinatura.value.trim() || null
        }
      );

      laudoAtual.value = response.data;
      emit('laudo-assinado', response.data);
      emit('laudo-finalizado', response.data);
      showBanner('success', 'Laudo assinado e finalizado com sucesso!');
      
    } else if (acaoAssinatura.value === 'finalizar_adendo') {
      await executarFinalizarAdendo();
      
    } else if (acaoAssinatura.value === 'finalizar_revisao') {
      await executarFinalizarRevisao();
    }

    cancelarAssinatura();

  } catch (error) {
    const errorMessage = error.response?.data?.detail || 'Erro ao processar a ação. Verifique sua senha e tente novamente.';
    showBanner('error', errorMessage);
  } finally {
    assinandoLaudo.value = false;
  }
};

const cancelarAssinatura = () => {
  mostrarModalAssinatura.value = false;
  senhaAssinatura.value = '';
  observacoesAssinatura.value = '';
  acaoAssinatura.value = ''; // Resetar para vazio
};

const exportarLaudo = async (formato) => {
  mostrarExportOptions.value = false;

  if (!laudoAtual.value) {
    showBanner('error', 'Nenhum laudo carregado para exportar.');
    return;
  }

  try {
    if (formato === 'pdf') {
      // Gerar PDF usando o endpoint do backend
      await medicalReportsService.gerarPDFLaudo(laudoAtual.value.id);
    } else if (formato === 'txt') {
      // Converter HTML para texto incluindo revisão
      const textOnly = laudoCompletoParaExibicao.value.replace(/<[^>]*>/g, '');
      const blob = new Blob([textOnly], { type: 'text/plain' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `laudo_${props.paciente?.nome || 'paciente'}_${new Date().toISOString().split('T')[0]}.txt`;
      a.click();
      URL.revokeObjectURL(url);
    } else {
      showBanner('warning', `Exportação em formato ${formato.toUpperCase()} será implementada em breve.`);
    }
  } catch (error) {
    console.error('Erro ao exportar laudo:', error);
    showBanner('error', 'Erro ao exportar laudo. Tente novamente.');
  }
};

const abrirModalMascara = () => {
  emit('abrir-modal-mascara');
};

// Função para mostrar aviso quando não existe agendamento
const mostrarAvisoSemAgendamento = () => {
  mostrarAvisoAgendamento.value = true;
  mensagemAvisoAgendamento.value = `Não foi encontrado agendamento para o exame com número de acesso: ${props.paciente?.numAcesso || 'N/A'}. \n  \nPara criar um laudo, é necessário que o exame esteja agendado no sistema. Entre em contato com a administração para verificar o status do agendamento.`;
  laudoAtual.value = null;
  conteudoLaudo.value = '';
  statusLaudo.value = 'pendente';
  mascaraSelecionada.value = '';
  timelineLaudo.value = [];
  carregandoLaudo.value = false;
};

// Função auxiliar para forçar carregamento do conteúdo no editor
const carregarConteudoNoEditor = async (conteudo, cursorPosition = null) => {
  if (!conteudo || !quillEditor.value) return;

  await nextTick();
  setTimeout(() => {
    try {
      const quill = quillEditor.value.getQuill();
      if (quill && quill.root) {
        quill.root.innerHTML = conteudo;
        quill.update();

        // Garantir que o container tenha scroll adequado
        if (quill.container) {
          quill.container.style.overflowY = 'auto';
          quill.container.style.maxHeight = 'none';
          quill.container.style.minHeight = '200px';
        }

        // Restaurar a posição do cursor se fornecida
        if (cursorPosition !== null && cursorPosition >= 0) {
          try {
            quill.setSelection(cursorPosition, 0);
          } catch (error) {
            // Se a posição for inválida, colocar o cursor no final
            const length = quill.getLength();
            if (length > 0) {
              quill.setSelection(length - 1, 0);
            }
          }
        }

        // Forçar foco para garantir que o conteúdo seja visível
        quill.focus();

        // Ajustar scroll se necessário
        setTimeout(() => {
          if (quill.root && quill.root.scrollHeight > quill.root.clientHeight) {
            quill.root.style.overflowY = 'auto';
          }
        }, 100);
      }
    } catch (error) {
      // Erro silencioso ao forçar carregamento do conteúdo
    }
  }, 300);
};

// ================================
// MÉTODOS DE CONTROLE DO MODAL
// ================================



const fecharModal = () => {
  // Limpar estados
  conteudoLaudo.value = '';
  statusLaudo.value = 'pendente';
  mascaraSelecionada.value = '';
  laudoAtual.value = null;
  mascaras.value = [];
  novoAdendoConteudo.value = '';
  notasRevisao.value = '';
  activeTab.value = 'laudo';
  timelineLaudo.value = [];

  // Limpar aviso de agendamento
  mostrarAvisoAgendamento.value = false;
  mensagemAvisoAgendamento.value = '';

  // Limpar PDF
  pdfUrl.value = '';
  carregandoPDF.value = false;
  erroPDF.value = '';

  // Limpar timers
  if (autoSaveTimer.value) {
    clearTimeout(autoSaveTimer.value);
    autoSaveTimer.value = null;
  }

  // Limpar estados de loading
  carregandoLaudo.value = false;
  salvandoLaudo.value = false;
  carregandoMascaras.value = false;
  salvandoAutomaticamente.value = false;
  ultimoSalvamento.value = '';
  revisandoLaudo.value = false;
  assinandoLaudo.value = false;
  salvandoAdendo.value = false;

  // Fechar modais
  mostrarModalAssinatura.value = false;
  mostrarTimeline.value = false;
  mostrarExportOptions.value = false;

  // Limpar dados dos modais
  senhaAssinatura.value = '';
  observacoesAssinatura.value = '';

  // Resetar último paciente carregado
  ultimoPacienteCarregado.value = null;

  // [NOVO] Limpar estados do BannerMessage
  showBannerMessage.value = false;
  bannerMessage.value = '';
  bannerType.value = 'error';
  appointmentExists.value = false;
  currentAppointment.value = null;

  // Emitir evento de fechamento
  emit('close');
};

// Computed para verificar se o usuário é médico
const userStore = useUserStore();
const isMedico = computed(() => {
  const grupos = userStore.grupos || [];
  // Verificar se o usuário pertence a grupos de médicos
  return grupos.some(grupo =>
    grupo.toLowerCase().includes('medico') ||
    grupo.toLowerCase().includes('radiologista') ||
    grupo.toLowerCase().includes('médico') ||
    grupo.toLowerCase().includes('doctor')
  );
});

// Computed para determinar o status de exibição (incluindo RECALLED)
const displayStatus = computed(() => {
  if (isRecallBlocked.value) {
    return 'RECALLED';
  }
  return laudoAtual.value?.status || 'PENDING';
});

// Computed para o status formatado baseado no status de exibição - Paleta Moderna 2024
const displayStatusFormatado = computed(() => {
  const status = displayStatus.value;
  const statusMapping = {
    'PENDING': { label: 'Pendente', class: 'text-yellow-800', bg: 'bg-yellow-100', border: 'border-yellow-500', icon: 'Clock' },
    'DRAFT': { label: 'Rascunho', class: 'text-indigo-800', bg: 'bg-indigo-100', border: 'border-indigo-500', icon: 'FileTextIcon' },
    'IN_PROGRESS': { label: 'Em Andamento', class: 'text-amber-800', bg: 'bg-amber-100', border: 'border-amber-500', icon: 'FileEdit' },
    'COMPLETED': { label: 'Finalizado', class: 'text-emerald-800', bg: 'bg-emerald-100', border: 'border-emerald-500', icon: 'CheckCircle' },
    'REVIEWED': { label: 'Revisado', class: 'text-violet-800', bg: 'bg-violet-100', border: 'border-violet-500', icon: 'Eye' },
    'DELIVERED': { label: 'Entregue', class: 'text-blue-800', bg: 'bg-blue-100', border: 'border-blue-500', icon: 'Truck' },
    'CANCELLED': { label: 'Cancelado', class: 'text-red-800', bg: 'bg-red-100', border: 'border-red-500', icon: 'XCircle' },
    'RECALLED': { label: 'Reconvocado', class: 'text-orange-800', bg: 'bg-orange-100', border: 'border-orange-500', icon: 'AlertTriangle' }
  };
  
  return statusMapping[status] || statusMapping['PENDING'];
});

// Estado para controlar a visualização do PDF
const pdfUrl = ref('');
const carregandoPDF = ref(false);
const erroPDF = ref('');

// Função para carregar o PDF do laudo
const carregarPDFLaudo = async () => {
  if (!laudoAtual.value || mostrarAvisoAgendamento.value) {
    return;
  }

  // Se o laudo estiver pendente, não tentar carregar o PDF
  if (laudoAtual.value.status === 'PENDING') {
    carregandoPDF.value = false;
    erroPDF.value = '';
    pdfUrl.value = '';
    return;
  }

  carregandoPDF.value = true;
  erroPDF.value = '';

  try {
    // Verificar se o laudo tem conteúdo para gerar PDF
    const hasContent = !!(laudoAtual.value.content || laudoAtual.value.addenda);
    const hasContentText = laudoAtual.value.content && laudoAtual.value.content.trim();
    const hasAddendaText = laudoAtual.value.addenda && laudoAtual.value.addenda.trim();

    if (!hasContent) {
      erroPDF.value = 'Este laudo ainda não possui conteúdo para visualização. O PDF será gerado quando o laudo for finalizado.';
      pdfUrl.value = '';
      return;
    }

    // Verificar se há conteúdo real (não apenas espaços em branco)
    if (!hasContentText && !hasAddendaText) {
      erroPDF.value = 'O laudo possui estrutura mas não tem conteúdo textual. Aguarde a finalização do laudo.';
      pdfUrl.value = '';
      return;
    }

    // Usar URL direta do servidor para o PDF
    const timestamp = new Date().getTime();
    const pdfEndpoint = `/api/v1/medical-reports/laudos/${laudoAtual.value.id}/pdf/view/?t=${timestamp}`;

    // Definir a URL do PDF para o viewer
    pdfUrl.value = pdfEndpoint;

  } catch (error) {
    console.error('LaudoModal: Erro ao carregar PDF:', error);
    
    // Tratamento específico para diferentes tipos de erro
    if (error.message.includes('conteúdo') || error.message.includes('content')) {
      erroPDF.value = 'Este laudo ainda não possui conteúdo para visualização. O PDF será gerado quando o laudo for finalizado.';
    } else if (error.response?.status === 404) {
      erroPDF.value = 'PDF não encontrado. O laudo pode ainda não ter sido finalizado.';
    } else if (error.response?.status === 403) {
      erroPDF.value = 'Você não tem permissão para visualizar este PDF.';
    } else if (error.response?.status >= 500) {
      erroPDF.value = 'Erro no servidor ao gerar PDF. Tente novamente em alguns instantes.';
    } else {
      erroPDF.value = `Erro ao carregar o PDF: ${error.message}`;
    }

    // Limpar URL em caso de erro
    pdfUrl.value = '';
  } finally {
    carregandoPDF.value = false;
  }
};

// Watcher para carregar PDF quando o laudo mudar e o usuário não for médico
watch(() => laudoAtual.value, async (novoLaudo) => {
  if (novoLaudo && !isMedico.value && !mostrarAvisoAgendamento.value) {
    // Aguardar um pouco para garantir que o laudo foi carregado completamente
    await nextTick();
    await carregarPDFLaudo();
  }
});

// Função para download do PDF
const downloadPDF = () => {
  if (!pdfUrl.value) return;

  const link = document.createElement('a');
  link.href = pdfUrl.value;
  link.download = `laudo_${props.paciente?.nome || 'paciente'}_${new Date().toISOString().split('T')[0]}.pdf`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};





// Callbacks do PDFViewer
const onPDFLoaded = () => {
  // PDF carregado com sucesso
};

const onPDFError = (error) => {
  console.error('Erro no PDF:', error);
  erroPDF.value = `Erro ao carregar o PDF: ${error.message}`;
};

const onPDFPageChanged = () => {
  // Página alterada
};

// ================================
// MÉTODOS DE RECONVOCAÇÃO
// ================================

const handleRecallPatientFromComponent = async (recallData) => {
  try {
    // Executar reconvocação usando o recallQueueService
    const { recallQueueService } = await import('@/services/recallQueueService');
    const result = await recallQueueService.createRecall({
      appointment_id: recallData.appointment.id,
      type: recallData.type,
      reason: recallData.reason,
      reason_type: recallData.reason_type,
      description: recallData.description,
      additional_notes: recallData.additional_notes
    });

    if (result && result.data) {
      showBanner('success', 'Paciente adicionado à fila de reconvocação! Um administrativo irá agendar a nova consulta.');
      
      // Emitir evento para atualizar dados do paciente se necessário
      emit('paciente-atualizado', {
        ...props.paciente,
        appointmentId: result.data.id
      });
    }

  } catch (error) {
    console.error('LaudoModal: Erro ao reconvocar paciente:', error);
    showBanner('error', `Erro ao reconvocar paciente: ${error.message}`);
  }
};

const abrirModalReconvocar = async () => {
  try {
    // Buscar agendamento atual
    const appointment = await scheduleService.getAppointmentByAccessionNumber(props.paciente.numAcesso);
    
    if (!appointment) {
      console.log('Agendamento não encontrado para reconvocação');
      return;
    }

    // Verificar permissões de reconvocação do backend
    if (appointment.can_recall === false) {
      console.log('Usuário não tem permissão para reconvocar:', appointment.recall_error_message);
      return;
    }

    // Armazenar dados do agendamento para usar na reconvocação
    currentAppointment.value = appointment;
  } catch (error) {
    console.error('LaudoModal: Erro ao buscar dados do agendamento para reconvocação:', error);
  }
};

// Função para verificar se o laudo pode ser feito
const verificarPermissaoLaudo = async () => {
  if (!props.paciente?.numAcesso) {
    console.log('LaudoModal: Sem accession number, não é possível verificar permissão');
    return true; // Permite por padrão se não tiver accession number
  }

  try {
    // Verificar se existe série de impressão
    const printSeriesResponse = await apiClient.get(`/api/v1/pacs/check_print_series/${props.paciente.numAcesso}/`);
    if (printSeriesResponse.ok) {
      const printSeriesData = await printSeriesResponse.json();
      hasPrintSeries.value = printSeriesData.has_print_series;
      console.log('LaudoModal: Verificação de série de impressão:', printSeriesData);
    }

    // Buscar configuração do serviço usando o accession number
    const appointmentResponse = await medicalReportsService.buscarAgendamentoPorAccession(props.paciente.numAcesso);
    if (appointmentResponse && appointmentResponse.data && appointmentResponse.data.service) {
      serviceConfig.value = appointmentResponse.data.service;
      canLaudoWithoutPrintSeries.value = appointmentResponse.data.service.permitir_laudo_sem_serie_impressao !== false;
      console.log('LaudoModal: Configuração do serviço:', appointmentResponse.data.service);
    }

    // Verificar se pode fazer laudo
    const podeFazerLaudo = hasPrintSeries.value || canLaudoWithoutPrintSeries.value;
    console.log('LaudoModal: Permissão para laudar:', {
      hasPrintSeries: hasPrintSeries.value,
      canLaudoWithoutPrintSeries: canLaudoWithoutPrintSeries.value,
      podeFazerLaudo
    });

    return podeFazerLaudo;

  } catch (error) {
    console.error('LaudoModal: Erro ao verificar permissão de laudo:', error);
    return true; // Permite por padrão em caso de erro
  }
};



</script>

<style scoped>
/* Customizações do Quill */
:deep(.ql-toolbar) {
  flex-shrink: 0;
  /* Impede que a toolbar encolha */
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
  border-bottom: 1px solid #d1d5db;
  background-color: #ffffff;
  /* Sempre branco */
}

:deep(.ql-container) {
  flex: 1;
  /* Faz o container do editor crescer */
  overflow-y: auto;
  /* ATIVA A ROLAGEM AQUI */
  min-height: 0;
  /* Essencial para o flexbox calcular a altura corretamente */
  border-bottom-left-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
  background-color: #ffffff;
  /* Sempre branco */
  max-height: none;
  /* Remove qualquer limite de altura */
}

/* Ajustes gerais de layout do editor */
.quill-editor-custom {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 300px;
  /* Altura mínima para o editor */
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  background-color: #ffffff;
  /* Sempre branco */
  overflow: hidden;
  /* Impede overflow do container principal */
}

:deep(.ql-editor) {
  padding: 12px;
  line-height: 1.6;
  font-size: 14px;
  color: #1f2937;
  /* Sempre texto escuro */
  background-color: #ffffff;
  /* Sempre fundo branco */
  min-height: 200px;
  /* Altura mínima para o editor */
  overflow-y: auto;
  /* Garante scroll interno */
  word-wrap: break-word;
  /* Quebra palavras longas */
  white-space: pre-wrap;
  /* Preserva quebras de linha */
}

:deep(.ql-editor.ql-blank::before) {
  color: #9ca3af;
  font-style: italic;
  left: 12px;
}

/* Garantir que o container pai tenha altura adequada */
.flex-grow.flex.flex-col.min-h-0 {
  min-height: 400px;
  /* Altura mínima para o container */
  max-height: calc(100vh - 300px);
  /* Altura máxima responsiva */
  overflow: hidden;
  /* Impede overflow do container pai */
}

/* Garantir que os botões de ação sempre fiquem visíveis */
.flex-shrink-0.pt-4.border-t.dark\\:border-gray-700.space-y-3 {
  position: sticky;
  bottom: 0;
  z-index: 10;
  background: inherit;
  padding-bottom: 8px;
  margin-top: auto;
}

/* Garantir que o container principal tenha altura adequada */
.p-4.flex.flex-col.h-full {
  min-height: 0;
  overflow: hidden;
}

/* Garantir que o conteúdo principal tenha scroll quando necessário */
.flex-1.flex.flex-col.min-h-0 {
  overflow-y: auto;
  min-height: 0;
}

/* Garantir que os botões de ação tenham fundo sólido */
.flex-shrink-0.pt-4.border-t.dark\\:border-gray-700.space-y-3.bg-white.dark\\:bg-gray-800.sticky.bottom-0 {
  backdrop-filter: blur(8px);
  background-color: rgba(255, 255, 255, 0.95);
}

.dark .flex-shrink-0.pt-4.border-t.dark\\:border-gray-700.space-y-3.bg-white.dark\\:bg-gray-800.sticky.bottom-0 {
  background-color: rgba(31, 41, 55, 0.95);
}

/* Ajustes específicos para o modo painel */
.laudo-panel-root .quill-editor-custom {
  min-height: 300px;
  max-height: calc(100vh - 200px);
}

/* Ajustes para containers de abas */
div[v-show*="activeTab"] {
  min-height: 300px;
  max-height: calc(100vh - 350px);
  overflow: hidden;
}

/* Garantir que o conteúdo interno tenha scroll */
div[v-show*="activeTab"] .flex-grow {
  overflow-y: auto;
  min-height: 0;
}

/* Correções específicas para o Quill editor */
:deep(.ql-editor) {
  overflow-y: auto !important;
  max-height: none !important;
  min-height: 200px !important;
}

:deep(.ql-container) {
  overflow-y: auto !important;
  max-height: none !important;
  flex: 1 !important;
}

/* Garantir que o container do Quill não tenha altura limitada */
.quill-editor-custom {
  overflow: hidden !important;
}

/* Forçar que o conteúdo do editor seja scrollável */
:deep(.ql-editor p),
:deep(.ql-editor div),
:deep(.ql-editor h1),
:deep(.ql-editor h2),
:deep(.ql-editor h3),
:deep(.ql-editor ul),
:deep(.ql-editor ol) {
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
  max-width: 100% !important;
}

/* Remover bordas dos elementos de salvamento */
.flex-shrink-0.flex.items-center.justify-between {
  border: none !important;
  outline: none !important;
}

.flex-shrink-0.flex.items-center.justify-between>div {
  border: none !important;
  outline: none !important;
}

/* Garantir que os elementos de status de salvamento não tenham bordas */
.flex.items-center.gap-2>div {
  border: none !important;
  outline: none !important;
}

/* Remover qualquer padding ou margin que possa parecer borda */
.text-xs {
  border: none !important;
  outline: none !important;
  background: transparent !important;
}

/* Remover bordas de inputs e elementos do Quill */
:deep(input) {
  border: none !important;
  outline: none !important;
  background: transparent !important;
}

:deep([data-formula]),
:deep([data-link]),
:deep([data-video]) {
  border: none !important;
  outline: none !important;
  background: transparent !important;
}

/* Remover bordas de elementos específicos do Quill */
:deep(.ql-editor input),
:deep(.ql-editor [data-formula]),
:deep(.ql-editor [data-link]),
:deep(.ql-editor [data-video]) {
  border: none !important;
  outline: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

/* Garantir que elementos de formulário não tenham bordas */
:deep(form input),
:deep(form textarea) {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

/* Garantir que o status mantenha sua borda */
span[class*="border-"] {
  border-width: 1px !important;
  border-style: solid !important;
}

/* Regra específica para o status do laudo */
.flex.items-center.space-x-2>span:last-child {
  border-width: 1px !important;
  border-style: solid !important;
}

/* Regra mais específica para garantir cores do status */
.flex.items-center.space-x-2>span:last-child[class*="bg-"] {
  background-color: inherit !important;
}

/* Forçar cores específicas do status */
.flex.items-center.space-x-2>span:last-child.bg-gray-200 {
  background-color: #e5e7eb !important;
}

.flex.items-center.space-x-2>span:last-child.bg-blue-200 {
  background-color: #bfdbfe !important;
}

.flex.items-center.space-x-2>span:last-child.bg-orange-200 {
  background-color: #fed7aa !important;
}

.flex.items-center.space-x-2>span:last-child.bg-green-200 {
  background-color: #bbf7d0 !important;
}

.flex.items-center.space-x-2>span:last-child.bg-purple-200 {
  background-color: #ddd6fe !important;
}

.flex.items-center.space-x-2>span:last-child.bg-indigo-200 {
  background-color: #c7d2fe !important;
}

.flex.items-center.space-x-2>span:last-child.bg-red-200 {
  background-color: #fecaca !important;
}

/* Forçar cores específicas do status */
.flex.items-center.space-x-2>span:last-child.bg-red-200 {
  background-color: #fecaca !important;
}

/* Garantir que o modal de assinatura tenha prioridade máxima */
.modal-assinatura {
  z-index: 999999 !important;
  position: fixed !important;
}

/* Garantir que os campos de input do modal de assinatura tenham prioridade */
.modal-assinatura input,
.modal-assinatura textarea {
  z-index: 1000000 !important;
  position: relative !important;
}



/* [NOVO] Estilos para painel lateral */
.laudo-panel-root {
  position: relative;
  width: 100%;
  height: 100vh;
  background: #fff;
  color: #1f2937;
  display: flex;
  flex-direction: column;
  z-index: 1;
  overflow: hidden;
}

.laudo-panel-content {
  width: 100%;
  height: 100vh;
  background: #fff;
  color: #1f2937;
  display: flex;
  flex-direction: column;
  border-radius: 0;
  box-shadow: none;
  max-width: 100vw;
  min-width: 0;
}

@media (max-width: 900px) {

  .laudo-panel-content,
  .laudo-panel-root {
    width: 100vw;
    min-width: 0;
    max-width: 100vw;
  }
}

/* [CORRIGIDO] Estilos para painel lateral com suporte a tema escuro */
.laudo-panel-root {
  position: relative;
  width: 100%;
  height: 100vh;
  background: #fff;
  color: #1f2937;
  display: flex;
  flex-direction: column;
  z-index: 1;
  overflow: hidden;
}

.laudo-panel-root.dark {
  background: #1f2937;
  color: #f9fafb;
}

.laudo-panel-content {
  width: 100%;
  height: 100vh;
  background: #fff;
  color: #1f2937;
  display: flex;
  flex-direction: column;
  border-radius: 0;
  box-shadow: none;
  max-width: 100vw;
  min-width: 0;
}

.laudo-panel-content.dark {
  background: #1f2937;
  color: #f9fafb;
}

/* [NOVO] Suporte a tema escuro para o editor no modo painel */
.laudo-panel-root .quill-editor-custom {
  background-color: #fff;
  border-color: #d1d5db;
}

.laudo-panel-root.dark .quill-editor-custom {
  background-color: #374151;
  border-color: #4b5563;
}

.laudo-panel-root .ql-toolbar {
  background-color: #fff;
  border-color: #d1d5db;
}

.laudo-panel-root.dark .ql-toolbar {
  background-color: #374151;
  border-color: #4b5563;
}

.laudo-panel-root .ql-container {
  background-color: #fff;
  border-color: #d1d5db;
}

.laudo-panel-root.dark .ql-container {
  background-color: #374151;
  border-color: #4b5563;
}

.laudo-panel-root .ql-editor {
  background-color: #fff;
  color: #1f2937;
}

.laudo-panel-root.dark .ql-editor {
  background-color: #374151;
  color: #f9fafb;
}

@media (max-width: 900px) {

  .laudo-panel-content,
  .laudo-panel-root {
    width: 100vw;
    min-width: 0;
    max-width: 100vw;
  }
}
</style>